import { RecordRef } from "@cloudextend/common/core";
import { args, declareEvent } from "@cloudextend/common/events";

export const searchSuggestionAdded = declareEvent(
    "prp:core:search:Suggestion Added",
    args<{ suggestion: RecordRef }>()
);
